"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteConsignmentQueueBodySchema = void 0;
const zod_1 = require("zod");
const token_1 = require("../misc/token");
const activity_1 = require("../lib/activity");
exports.CompleteConsignmentQueueBodySchema = zod_1.z.object({
    auth: zod_1.z.string(),
    scope: zod_1.z.literal("aglive"),
    externalIds: token_1.ExternalIdsSchema.pick({ agliveToken: true }).required(),
    type: zod_1.z.literal(activity_1.ActivityTypeSchema.enum.completeConsignment),
    details: activity_1.CompleteConsignmentDetailSchema,
    createdAt: zod_1.z.string()
});
